import { User } from '../components/types';

export const getDisplayName = (user: User | null | undefined): string => {
  if (!user) return 'Unknown User';
  return user.displayName || 'Unknown User';
};